import * as React from "react";
import {Link} from "react-router-dom";
import QueueMusicIcon from '@mui/icons-material/QueueMusic';
import {MediaItem} from "../../../store/api/types";
import styles from './MediaCard.module.scss';

export type MediaCardVariant = 'vertical' | 'horizontal';

export interface MediaCardProps {
    item: MediaItem;
    onClick?: (item: MediaItem) => void;
    variant?: MediaCardVariant;
}

export const MediaCard: React.FC<MediaCardProps> = ({item, onClick, variant = 'vertical'}) => {

    if (variant === 'horizontal') {
        const inner = (
            <>
                {item.img ? (
                    <img src={item.img} alt={item.name} className={styles.mediaCard__hArt}/>
                ) : (
                    <div className={styles.mediaCard__hArtPlaceholder}>
                        <QueueMusicIcon sx={{fontSize: 28, opacity: 0.55}}/>
                    </div>
                )}
                <div className={styles.mediaCard__hText}>
                    <div className={styles.mediaCard__hTitle}>{item.name}</div>
                    <div className={styles.mediaCard__hSubtitle}>{item.artist}</div>
                </div>
            </>
        );

        return onClick ? (
            <div
                className={styles.mediaCard__horizontal}
                onClick={() => onClick(item)}
                role="button"
                tabIndex={0}
            >
                {inner}
            </div>
        ) : (
            <Link to={`/playlists/${item.id}`} className={styles.mediaCard__horizontal}>
                {inner}
            </Link>
        );
    }

    const inner = (
        <>
            {item.img ? (
                <img src={item.img} alt={item.name} className={styles.mediaCard__art}/>
            ) : (
                <div className={styles.mediaCard__artPlaceholder}>
                    <QueueMusicIcon sx={{fontSize: 44, opacity: 0.5}}/>
                </div>
            )}
            <div className={styles.mediaCard__meta}>
                <div className={styles.mediaCard__title}>{item.name}</div>
                <div className={styles.mediaCard__description}>{item.artist}</div>
            </div>
        </>
    );

    return onClick ? (
        <div
            className={styles.mediaCard__container}
            onClick={() => onClick(item)}
            role="button"
            tabIndex={0}
        >
            {inner}
        </div>
    ) : (
        <Link to={`/playlists/${item.id}`} className={styles.mediaCard__container}>
            {inner}
        </Link>
    );
}
